import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { GuestUserDto, MemberRole, UserDto } from '@picflow/types';
import { GalleryMemberService } from 'src/app/gallery-member.service';
import { TenantService } from 'src/app/services/tenant.service';
import { ButtonDirective } from 'src/app/shared/directives/button.directive';
import { AvatarPipe } from '../../../shared-extra/pipes/avatar.pipe';

@Component({
  selector: 'app-profile-preview',
  standalone: true,
  templateUrl: './profile-preview.component.html',
  styleUrls: ['./profile-preview.component.scss'],
  imports: [CommonModule, AvatarPipe, RouterLink, ButtonDirective],
})
export class ProfilePreviewComponent implements OnInit {
  @Input() user: UserDto;
  @Input() guest: GuestUserDto;
  @Input() email: string;

  role: MemberRole | 'guest' | 'visitor' | 'loading...' = 'loading...';
  labelColor = this.getLabelColor();

  private tenantService = inject(TenantService);
  private galleryMemberService = inject(GalleryMemberService);

  async ngOnInit() {
    if (this.guest) {
      this.role = 'visitor';
      this.labelColor = this.getLabelColor();
      return;
    }
    const [teamMembers, galleryMembers] = await Promise.all([
      this.tenantService.getMembers(),
      this.galleryMemberService.getAllGalleryMembers(),
    ]);

    const myId = this.user?.id || this.guest['id'];
    const teamMember = teamMembers.find(m => m.id === myId);
    if (teamMember) {
      this.role = teamMember.role;
    } else {
      const galleryMember = galleryMembers.find(m => m.id === myId);
      if (galleryMember) {
        this.role = 'guest';
      } else {
        this.role = 'visitor';
      }
    }

    this.labelColor = this.getLabelColor();
  }

  getLabelColor() {
    if (this.role === 'visitor') return 'grey-50';
    if (this.role === 'guest') return 'orange';
    if (this.role === 'member') return 'primary';
    return 'dark';
  }
}
